<script setup lang="ts">
import type {HTMLAttributes} from "vue";
import {tw} from "../../utils/tailwind.ts";

interface Props {
    error?: string|null,
    class?: HTMLAttributes['class'],
}

const props = withDefaults(defineProps<Props>(), {
    error: null
});

</script>

<template>
    <span
        v-if="error"
        :class="tw('text-red-500 text-sm', props.class)"
        v-text="error"
    />
</template>
